import {combineReducers} from '@reduxjs/toolkit';

import {userEntitlementsStateSlice} from './slices/user-entitlements-state.slice';
import {userEntitlementsSlice} from './slices/user-entitlements.slice';

export const userEntitlementsAssignedReducer = combineReducers({
    entitlements: userEntitlementsSlice.reducer,
    state: userEntitlementsStateSlice.reducer,
});
